import React from "react";
import { BnbLabel } from "../../../../utils/labels";
import { showModal } from "../../../../../../../common-deprecated/redux/actions/ModalActions";
import { Container } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Container";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as Button from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import * as Type from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import * as Styles from "../styles/Filters";
import useProAceFilters from "../../../../hooks/proace/useProAceFilters";
import { ProaceFilterType } from "../../../../../../../common-deprecated/types/CommonTypes";
import type { BuildAndBuyDispatchType } from "../../../../redux/store";
import { useBnbSelector } from "../../../../redux/store";
import CheckBoxFilter from "./CheckboxFilter";
import ProAceExteriorGallery from "./ProAceExteriorGallery";
import SeatFilter from "./SeatFilter";
import { MODAL_PROACE } from "../../../../utils/modalConstants";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

const ModelFilters = (): JSX.Element => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const modelFilter = useBnbSelector((state) => state.modelFilter);
    const { name, filterValues, dimensions } = modelFilter;
    const { checkBoxFilters, seatFilter, disabledWheelBase, setFilterValue } = useProAceFilters();

    return (
        <Container mt={5}>
            <div>
                <Type.H1 headingType="gamma">{name}</Type.H1>
                <ProAceExteriorGallery />
            </div>
            <Flex.Row>
                {checkBoxFilters.map((filter) => (
                    <Styles.FilterWrapper key={filter.code} width={{ _: 1, md: 1 / 2, lg: 1 / 4 }}>
                        <CheckBoxFilter
                            filter={filter}
                            selectedValue={filterValues[filter.code]}
                            onSelect={(value) => setFilterValue(filter.code, value)}
                        />
                        {filter.code === ProaceFilterType.WheelBase && !disabledWheelBase && (
                            <Button.Link
                                hasIconRight
                                onClick={() => {
                                    dispatch(
                                        showModal({
                                            type: MODAL_PROACE,
                                            dimensions,
                                        }),
                                    );
                                }}
                            >
                                <Text.Button>
                                    <BnbLabel label="viewDimensions" />
                                </Text.Button>
                                <IconWrapper iconColor="primaryBlack">
                                    <Icon variant="info" />
                                </IconWrapper>
                            </Button.Link>
                        )}
                    </Styles.FilterWrapper>
                ))}
                {seatFilter && (
                    <Styles.FilterWrapper width={{ _: 1, md: 1 / 2, lg: 1 / 4 }}>
                        <SeatFilter
                            filter={seatFilter}
                            selectedValue={filterValues[seatFilter.code]}
                            onSelect={(value) => setFilterValue(seatFilter.code, value)}
                        />
                    </Styles.FilterWrapper>
                )}
            </Flex.Row>
        </Container>
    );
};

export default ModelFilters;
